<template>
  <v-card>
    <v-container class="py-0">
      <v-row>
        <v-col cols="12" sm="4">
          <v-card-title>Departments</v-card-title>
          <v-card-subtitle>
            View existing departments or create a new department
          </v-card-subtitle>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="auto" class="my-auto">
          <v-text-field
            class="my-auto mr-4 hideMessages"
            label="Department name"
            single-line
            dense
            outlined
            clearable
            prepend-inner-icon="search"
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-col sm="auto" class="my-auto mr-4">
          <create-team-dialog
            v-if="is_admin"
            v-on:save="getTeams"
          ></create-team-dialog>
        </v-col>
      </v-row>
    </v-container>
    <v-card-text>
      <v-skeleton-loader
        v-if="loading"
        type="table-thead, table-tbody"
      ></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="items"
        :search="search"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100]
        }"
        @click:row="rowClick"
        class="row-pointer"
      >
        <template v-slot:item.fullName="{ item }">
          <team-chip :team="item" include-link></team-chip>
        </template>
        <template v-slot:item.coreBoard="{ item }">
          <v-btn
            icon
            @click.stop="
              $router.push({ path: '/departments/' + item.id + '/coreboard' })
            "
          >
            <v-icon>insert_chart</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            text
            class="light-background"
            small
            color="info"
            :to="'/departments/' + item.id"
          >
            View
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import CreateTeamDialog from "@/components/teams/CreateTeamDialog";
export default {
  name: "TeamList",
  components: {
    "create-team-dialog": CreateTeamDialog
  },
  props: {},
  data: () => ({
    search: "",
    loading: true,
    options: {},
    headers: [
      { text: "Department", value: "fullName" },
      { text: "Managers", value: "fullManagerCount" },
      { text: "Members", value: "fullMemberCount" },
      { text: "CoreBoard", value: "coreBoard", sortable: false },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  computed: {
    items() {
      return this.teams;
    },
    ...mapGetters({
      teams: "team/teams",
      is_admin: "profile/is_admin"
    })
  },
  created() {
    this.getTeams();
  },
  methods: {
    getTeams() {
      this.$store
        .dispatch("team/getTeams")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            `An error occured while loading your departments.`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(item) {
      this.$router.push({ path: "/departments/" + item.id });
    }
  }
};
</script>
